import { Dialog, DialogProps } from "@mui/material";

import AppModalContent from "@/common/components/Modals/AppModalContent";
import { ViewVariant } from "@/common/ts/layout";

import RepairWorkView, { RepairWorkViewProps } from "./RepairWorkView";

export interface OwnProps {
  viewProps: RepairWorkViewProps;
}

type Props = OwnProps & DialogProps;

export default function RepairWorkViewModal({ viewProps, ...dialogProps }: Props) {
  return (
    <Dialog fullWidth maxWidth='lg' {...dialogProps}>
      <AppModalContent>
        <RepairWorkView
          onDeleted={() => {
            dialogProps.onClose && dialogProps.onClose({}, "escapeKeyDown");
          }}
          {...viewProps}
          displayProps={{
            viewVariant: ViewVariant.Tab, // TODO: must be Modal
            ...viewProps?.displayProps,
          }}
        />
      </AppModalContent>
    </Dialog>
  );
}
